import React, { PropTypes } from "react";
import styles from "components/documents/export-button.scss";
import { Button } from "components/common/button";

export const ExportButton = ({
  accountSlug,
  glCodes,
  onLinkAccount,
  onStartExportMode,
  selectedDocumentIds
}) => (
  <span className={ styles.button }>
    { renderExportButton(
        accountSlug,
        glCodes,
        selectedDocumentIds,
        onLinkAccount,
        onStartExportMode
    ) }
  </span>
);

ExportButton.propTypes = {
  accountSlug: PropTypes.string.isRequired,
  glCodes: PropTypes.arrayOf(PropTypes.object).isRequired,
  onLinkAccount: PropTypes.func.isRequired,
  onStartExportMode: PropTypes.func.isRequired,
  selectedDocumentIds: PropTypes.arrayOf(PropTypes.string).isRequired
};

const renderExportButton = (
  accountSlug,
  glCodes,
  selectedDocumentIds,
  onLinkAccount,
  onStartExportMode
) => {
  // TODO: This is a temporary fix until the API call for GET integration details is created.
  // Until then we have to judge whether or not an integration exists based on the existence of GL codes.
  if (glCodes.length === 0) {
    return <Button onClick={ () => onLinkAccount(accountSlug) } primary>Link your accounting software</Button>;
  }
  if (selectedDocumentIds.length > 0) {
    return <Button onClick={ () => onStartExportMode() } primary>Export Selected</Button>;
  }
  return <Button onClick={ () => onStartExportMode() } primary>Export All</Button>;
};



// WEBPACK FOOTER //
// ./src/js/components/documents/exports/export-button.jsx